// DEVELOPED BY TAHA HUSSAIN
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request.url.includes('token')) {
            // add authorization header with basic auth credentials if available
            let UserData = JSON.parse(localStorage.getItem('UserData'));
            if (UserData && UserData.Token) {
                request = request.clone({
                    setHeaders: {
                        'Authorization': `Bearer ` + JSON.parse(localStorage.getItem('UserData')).Token,
                        // 'Authorization': `Bearer ZlJYm8Bf9Egrq-tnHI61_3KyQtUCHoO0mfM7Ya8mA1cfhAzM7iU9OP9UFohSrirasVTT2SnSQc77YU4xcl5elGUSZDYLFO1Xu9lVqctNjJdVaMcOWYxLjCckoWJHs53IyiDo1fOJbgkUO4wO0zexpD6ZLjlTl5ZncaEs9UKR_4-_7i93aSmNTKzt5jhvmsJC5KDc-7VLPQeO7XXYqu0S4kqakBmRAex4rvWayAcmUBFqR-kqsyZtkS2tzaH3oE4p3kcRu1ssKP9WKLxG71Dj7yg5gkK3sqSsC2Ww3r-BjbeTVZ9zi70F1snoov_yVq249DKsHIluaMxCIFS2bHW2NDhqP6u3qhEs7nE1S3oDpOcuwjau5WrOwBdRdpEdDhmDsjcNe0mLwOYe67w2vLtL9P0CF8frtTi8qzQyF1iZ4lgdtxyC`,                    
                        'Access-Control-Allow-Origin': '*'
                    }
                });
            }
            else {

            }
        }
        return next.handle(request);
    }
}

// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse }
//   from '@angular/common/http';

// import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/operator/do';

// @Injectable()
// export class BasicAuthInterceptor implements HttpInterceptor {
//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {

//     return next.handle(req).do(evt => {
//       if (evt instanceof HttpResponse) {
//         console.log('---> status:', evt.status);
//         console.log('---> filter:', req.params.get('filter'));
//       }
//     });

//   }
// }